.container {
    --padding: 128px;
    height: 100%;
    width: calc(100% - var(--padding));
    background-color: var(--white);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 var(--padding);
    overflow: hidden;
    border-top-left-radius: 8px;
}

.container svg,
.container img {
    position: relative;
    z-index: 1;
}

/* when the page gets smaller then 700px hide the svg */
@media (max-width: 1100px) {
    .container svg,
    .container img {
        display: none;
    }
}

.content-container {
    max-width: 600px;
}

.carousel-wrapper {
    height: 100%;
    display: flex;
    align-items: center;
}

.carousel-wrapper > div {
    height: 100%;
    width: 100%;
}
